import styled from 'styled-components';
import { Button, Modal, Select } from '@hiiretail/synergy-ui';

export const AssignRoleModal = styled(Modal)`
  height: 70vh;
`;

export const CancelButton = styled(Button)`
  margin-right: 16px;
`;

export const RoleSelect = styled(Select)`
  height: 460px;
`;
